<template>
  <div class="experts">
    <Expert
      :data="item"
      :eduMap="eduMap"
      v-for="(item, index) in data"
      :key="index"
      class="experts-item"
    />
  </div>
</template>
<script>
import { EDU_GRADE } from "@/constant/dict";
import Expert from "@/components/Expert/index";
export default {
  components: {
    Expert,
  },
  props: {
    data: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      eduMap: {},
    };
  },
  created() {
    this.getDict();
  },
  methods: {
    async getDict() {
      const res = await this.$store.dispatch("getDictData", EDU_GRADE);
      const eduMap = {};
      res.forEach((item) => {
        eduMap[item.dictValue] = item.dictLabel;
      });
      this.eduMap = eduMap;
    },
  },
};
</script>
<style lang="scss" scoped>
.experts {
  display: grid;
  grid-template-columns: repeat(4, calc(25% - 8px));
  gap: 15px;
  &-item {
    background: white;
  }
}
</style>
